import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2f5dfbfe&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/custom.css?vue&type=style&index=0&id=2f5dfbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dfbfe",
  null
  
)

export default component.exports